import React, { useState, useEffect } from "react";

//import ReactDOM from "react-dom";

import {
  VictoryLine,
  VictoryScatter,
  VictoryTheme,
  VictoryChart,
  VictoryAxis as VictoryAxisOrig,
  VictoryArea,
  VictoryLabel,
} from "victory";

// Victory types are incompatible with React 19 @types/react
const VictoryAxis = VictoryAxisOrig as any;
const VictoryScatterAny = VictoryScatter as any;
import { Button } from "./ui/button";
import {
  degreeText,
  getTemperatureRanges,
  temperatureRangeColours,
  temperatureRangeNames,
  //getEnabledAnnotationsFromSegments,
  //getPrincipalEnabledAnnotationFromSegments,
  getPriorityEnabledAnnotationsFromSegments,
  parseRateValue,
  parseSegmentNumber,
} from "../helpers/unitHelpers";

const FiringGraph = ({ sortedSegments, degrees, project, showAnnotations = true }: { sortedSegments: any; degrees: any; project: any; showAnnotations?: boolean }) => {
  const [enabledAnnotations, setEnabledAnnotations] = useState<Record<string, any>>({});

  useEffect(() => {
    const enabled = getPriorityEnabledAnnotationsFromSegments(
      sortedSegments,
      project?.glass,
      degrees
    );
    setEnabledAnnotations(enabled);
  }, [project, sortedSegments, degrees]);
  const handleChangedCheckbox = (key: any) => {
    setEnabledAnnotations({
      ...enabledAnnotations,
      [key]: !enabledAnnotations[key],
    });
  };

  let elapsedMins = 0;
  let currentTemperature = 20;
  let data = [{ time: elapsedMins, temperature: currentTemperature }];
  sortedSegments.forEach((segment: any) => {
    const rate = parseRateValue(segment.rate);
    const temp = parseSegmentNumber(segment.temperature);
    const hold = parseSegmentNumber(segment.hold);
    if (rate > 0) {
      elapsedMins += Math.abs(temp - currentTemperature) / (rate / 60);
    }
    data = data.concat([{ time: elapsedMins / 60, temperature: temp }]);
    if (hold !== 0) {
      elapsedMins += hold;
      data = data.concat([{ time: elapsedMins / 60, temperature: temp }]);
    }
    currentTemperature = temp;
  });
  const temperatureRanges: Record<string, any> = getTemperatureRanges(project?.glass, degrees);

  return (
    <div className="flex gap-4">
      <div className="flex-[7]">
        <VictoryChart theme={VictoryTheme.material}>
          <VictoryAxis
            dependantAxis
            tickFormat={(x: any) => Math.floor(x)}
            //        tickValues={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((x) => x * 60)}
            label="Hours"
            style={{ axisLabel: { padding: 32 } }}
            theme={VictoryTheme.material}
          />
          <VictoryAxis
            dependentAxis
            label={`Temperature ${degreeText(degrees)}`}
            style={{ axisLabel: { padding: 38 } }}
            theme={VictoryTheme.material}
          />
          {showAnnotations &&
            Object.keys(temperatureRanges).map(
              (key) =>
                enabledAnnotations[key] && (
                  <VictoryArea
                    key={`${key}.area`}
                    style={{ data: { fill: temperatureRangeColours[key] } }}
                    data={[
                      {
                        x: 0,
                        y: temperatureRanges[key][1],
                        y0: temperatureRanges[key][0],
                      },
                      {
                        x: elapsedMins / 60,
                        y: temperatureRanges[key][1],
                        y0: temperatureRanges[key][0],
                      },
                    ]}
                  />
                )
            )}
          {showAnnotations &&
            Object.keys(temperatureRanges).map(
              (key) =>
                enabledAnnotations[key] && (
                  <VictoryLabel
                    key={`${key}.label`}
                    text={temperatureRangeNames[key]}
                    style={{ fontSize: 6 }}
                    datum={{
                      x: (elapsedMins / 60) * 0.9,
                      y: (temperatureRanges[key][0] + temperatureRanges[key][1]) / 2,
                    }}
                    textAnchor="middle"
                  />
                )
            )}
          <VictoryLine
            data={data}
            x={"time"}
            y={"temperature"}
            style={{
              data: { strokeWidth: 1.5, strokeLinecap: "round" },
            }}
          />
          <VictoryScatterAny
            data={data}
            x={"time"}
            y={"temperature"}
            dx={-12}
            size={3}
            style={{ data: { fill: "red", strokeWidth: 5, stroke: "none" } }}
          />
        </VictoryChart>
      </div>

      {showAnnotations && (
        <div className="flex-1">
          <div className="text-xs font-semibold text-muted-foreground uppercase tracking-[.06em] mb-2">
            Process temps
            {project?.glass && (
              <div className="normal-case tracking-normal font-medium text-muted-foreground mt-0.5">
                for {project.glass}
              </div>
            )}
          </div>
          <div className="flex flex-col gap-1.5">
            {Object.keys(temperatureRanges).map((key) => {
              const on = !!enabledAnnotations[key];
              return (
                <Button
                  key={key}
                  variant="outline"
                  size="sm"
                  onClick={() => handleChangedCheckbox(key)}
                  className={`justify-start gap-2 h-auto py-1.5 font-medium ${
                    on
                      ? "bg-accent text-foreground"
                      : "text-muted-foreground"
                  }`}
                >
                  <span
                    className="h-3.5 w-3.5 rounded-[4px] shrink-0"
                    style={{ background: temperatureRangeColours[key] }}
                  />
                  {temperatureRangeNames[key]}
                </Button>
              );
            })}
          </div>
          <p className="mt-2.5 text-[11px] text-muted-foreground leading-snug">
            Toggle to overlay kiln process bands on the graph.
          </p>
        </div>
      )}
    </div>
  );
};

export default FiringGraph;

/* dependentAxis
        crossAxis
        
        domain={[0, 1000]}
        
        
        <VictoryAxis label="Segment Order" minDomain={{ x: 0 }} />
      <VictoryAxis dependantAxis tickFormat={(y) => `${y}degrees`} />



          <span style={{ paddingLeft: "8px", paddingRight: "4px" }}>
            <input
              key={key}
              type="checkbox"
              checked={!!enabledAnnotations[key]}
              onChange={() => {
                handleChangedCheckbox(key);
              }}
            />
            {temperatureRangeNames[key]}
          </span>


        */
